"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HotelTariffCardDesktop = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _localization = require("@lt/localization");
var _HotelTariffOffer = require("./HotelTariffOffer/HotelTariffOffer");
var _HotelRoomDescription = _interopRequireDefault(require("../HotelRoomDescription"));
var _CashBack = _interopRequireDefault(require("../CashBack"));
var _VerticalGallery = _interopRequireDefault(require("../VerticalGallery"));
var _Hotel = _interopRequireDefault(require("../../icons-react/rebrand/Hotel"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var IMAGE_HEIGHT = 220;
var NoPhoto = function NoPhoto() {
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(StyledEmptyMessageContainer, null, /*#__PURE__*/_react["default"].createElement(StyledNoImageIcon, null), /*#__PURE__*/_react["default"].createElement(StyledEmptyMessageLabel, null, t('hotel.room.noFoto')));
};
var HotelTariffCardDesktop = exports.HotelTariffCardDesktop = function HotelTariffCardDesktop(_ref) {
  var onOfferClicked = _ref.onOfferClicked,
    bonusCount = _ref.bonusCount,
    area = _ref.area,
    hotelFacilities = _ref.hotelFacilities,
    labels = _ref.labels,
    mealTypes = _ref.mealTypes,
    tourists = _ref.tourists,
    room = _ref.room,
    offers = _ref.offers,
    onClickGallery = _ref.onClickGallery,
    labelColor = _ref.labelColor,
    textColor = _ref.textColor,
    size = _ref.size,
    className = _ref.className,
    hasCashbackLabel = _ref.hasCashbackLabel,
    cashbackIconWebp = _ref.cashbackIconWebp,
    cashbackIconPng = _ref.cashbackIconPng,
    cashbackTooltipText = _ref.cashbackTooltipText,
    cashbackLabel = _ref.cashbackLabel;
  var images = room.images,
    description = room.description,
    facilities = room.facilities,
    roomName = room.name_ru,
    originalName = room.name_en,
    idRoom = room.id;
  var noPhotoMessage = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react["default"].createElement(NoPhoto, null);
  }, []);
  var roomImages = (0, _react.useMemo)(function () {
    return images ? images.map(function (image) {
      return image.x900;
    }) : [];
  }, [images]);
  return /*#__PURE__*/_react["default"].createElement(StyledHotelTariffCard, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(GalleryWrap, {
    hasImages: roomImages.length !== 0
  }, bonusCount ? /*#__PURE__*/_react["default"].createElement(_CashBack["default"], {
    className: "hotelDesktop",
    count: "+".concat(bonusCount),
    labelColor: labelColor,
    textColor: textColor,
    isMobile: false,
    size: size,
    label: cashbackLabel,
    hasCashbackLabel: hasCashbackLabel,
    cashbackIconWebp: cashbackIconWebp,
    cashbackIconPng: cashbackIconPng,
    cashbackTooltipText: cashbackTooltipText
  }) : null, /*#__PURE__*/_react["default"].createElement(StyledVerticalGallery, {
    imageHeight: IMAGE_HEIGHT,
    images: roomImages,
    emptyMessage: noPhotoMessage,
    id: idRoom,
    onClickGallery: onClickGallery
  })), /*#__PURE__*/_react["default"].createElement(StyledHotelRoomDescription, {
    area: area,
    description: description,
    facilities: facilities,
    roomName: roomName,
    originalName: originalName,
    hotelFacilities: hotelFacilities,
    labels: labels
  }), /*#__PURE__*/_react["default"].createElement(StyledTariffes, null, mealTypes.map(function (_ref2) {
    var id = _ref2.id,
      descriptionMeal = _ref2.description;
    var offersTariff = offers[id];
    return offersTariff ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledDescriptionMeal, {
      key: "meal_".concat(descriptionMeal)
    }, descriptionMeal), /*#__PURE__*/_react["default"].createElement(StyledHotelOffers, null, offersTariff.map(function (offer, idxOffer) {
      var key = "".concat(idxOffer - offer.price);
      return /*#__PURE__*/_react["default"].createElement(_HotelTariffOffer.HotelTariffOffer, {
        key: key,
        tourists: tourists,
        onOfferClicked: onOfferClicked,
        offer: offer
      });
    }))) : null;
  })));
};
var GalleryWrap = _styledComponents["default"].div.withConfig({
  displayName: "HotelTariffCardDesktop__GalleryWrap",
  componentId: "sc-1hxmve2-0"
})(["position:relative;overflow:hidden;border-radius:var(--border-radius);margin-right:0.5em;", ""], function (_ref3) {
  var hasImages = _ref3.hasImages;
  return hasImages && "cursor: pointer;";
});
var StyledVerticalGallery = (0, _styledComponents["default"])(_VerticalGallery["default"]).withConfig({
  displayName: "HotelTariffCardDesktop__StyledVerticalGallery",
  componentId: "sc-1hxmve2-1"
})(["width:230px;"]);
var StyledEmptyMessageContainer = _styledComponents["default"].div.withConfig({
  displayName: "HotelTariffCardDesktop__StyledEmptyMessageContainer",
  componentId: "sc-1hxmve2-2"
})(["height:200px;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:4px;border-radius:var(--border-radius);background:var(--grey3);"]);
var StyledNoImageIcon = (0, _styledComponents["default"])(_Hotel["default"]).withConfig({
  displayName: "HotelTariffCardDesktop__StyledNoImageIcon",
  componentId: "sc-1hxmve2-3"
})(["height:24px;path{fill:var(--white);}"]);
var StyledEmptyMessageLabel = _styledComponents["default"].div.withConfig({
  displayName: "HotelTariffCardDesktop__StyledEmptyMessageLabel",
  componentId: "sc-1hxmve2-4"
})(["color:var(--white);font-size:14px;font-style:normal;font-weight:400;white-space:pre-line;text-align:center;"]);
var StyledHotelTariffCard = _styledComponents["default"].div.withConfig({
  displayName: "HotelTariffCardDesktop__StyledHotelTariffCard",
  componentId: "sc-1hxmve2-5"
})(["display:flex;width:100%;min-height:16.25rem;justify-content:space-between;padding:0.5em;border-radius:0.5em;background:var(--white);"]);
var StyledHotelRoomDescription = (0, _styledComponents["default"])(_HotelRoomDescription["default"]).withConfig({
  displayName: "HotelTariffCardDesktop__StyledHotelRoomDescription",
  componentId: "sc-1hxmve2-6"
})(["display:flex;flex-direction:column;width:", ";", " gap:0.5em"], function (_ref4) {
  var doubleWidth = _ref4.doubleWidth;
  return doubleWidth ? '470px' : '230px';
}, function (_ref5) {
  var doubleWidth = _ref5.doubleWidth;
  return !doubleWidth && 'margin-left: 0;';
});
var StyledDescriptionMeal = _styledComponents["default"].div.withConfig({
  displayName: "HotelTariffCardDesktop__StyledDescriptionMeal",
  componentId: "sc-1hxmve2-7"
})(["color:var(--black);font-size:18px;font-style:normal;font-weight:500;"]);
var StyledHotelOffers = _styledComponents["default"].div.withConfig({
  displayName: "HotelTariffCardDesktop__StyledHotelOffers",
  componentId: "sc-1hxmve2-8"
})(["> div:first-child{border-top-left-radius:var(--border-radius);border-top-right-radius:var(--border-radius);}> div:not(:last-child){border-bottom:1px solid var(--grey3);}> div:last-child{border-bottom-left-radius:var(--border-radius);border-bottom-right-radius:var(--border-radius);}"]);
var StyledTariffes = _styledComponents["default"].div.withConfig({
  displayName: "HotelTariffCardDesktop__StyledTariffes",
  componentId: "sc-1hxmve2-9"
})(["display:flex;flex-direction:column;margin-left:auto;width:50%;gap:0.5em;"]);